interface AuditFiltersProps {
  adminUser: string
  action: string
  targetType: string
  dateFrom: string
  dateTo: string
  onAdminUserChange: (value: string) => void
  onActionChange: (value: string) => void
  onTargetTypeChange: (value: string) => void
  onDateFromChange: (value: string) => void
  onDateToChange: (value: string) => void
}

const ACTION_OPTIONS = [
  '',
  'account.pause',
  'account.resume',
  'account.tier_change',
  'account.override_change',
  'account.credits',
  'account.delete',
  'domain.reverify',
  'domain.status_change',
  'admin_user.added',
  'admin_user.removed',
  'admin_user.role_changed',
  'alert.rule_changed',
  'alert.test_fired',
  'engine.queue_flushed',
  'billing.credits_granted',
  'billing.overage_reset',
  'billing.tier_forced',
] as const

const TARGET_TYPE_OPTIONS = [
  '',
  'account',
  'domain',
  'admin_user',
  'alert',
  'engine',
  'billing',
] as const

const INPUT_CLASS =
  'rounded-lg border border-surface-3 bg-surface-0 px-3 py-1.5 text-sm text-text-primary'

export function AuditFilters({
  adminUser,
  action,
  targetType,
  dateFrom,
  dateTo,
  onAdminUserChange,
  onActionChange,
  onTargetTypeChange,
  onDateFromChange,
  onDateToChange,
}: AuditFiltersProps): React.JSX.Element {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <label htmlFor="audit-admin" className="mb-1 block text-xs font-medium text-text-secondary">
          Admin
        </label>
        <input
          id="audit-admin"
          type="text"
          placeholder="Email..."
          value={adminUser}
          onChange={(e) => onAdminUserChange(e.target.value)}
          className={INPUT_CLASS}
        />
      </div>
      <div>
        <label
          htmlFor="audit-action"
          className="mb-1 block text-xs font-medium text-text-secondary"
        >
          Action
        </label>
        <select
          id="audit-action"
          value={action}
          onChange={(e) => onActionChange(e.target.value)}
          className={INPUT_CLASS}
        >
          <option value="">All actions</option>
          {ACTION_OPTIONS.filter(Boolean).map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label
          htmlFor="audit-target-type"
          className="mb-1 block text-xs font-medium text-text-secondary"
        >
          Target Type
        </label>
        <select
          id="audit-target-type"
          value={targetType}
          onChange={(e) => onTargetTypeChange(e.target.value)}
          className={INPUT_CLASS}
        >
          <option value="">All targets</option>
          {TARGET_TYPE_OPTIONS.filter(Boolean).map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label
          htmlFor="audit-date-from"
          className="mb-1 block text-xs font-medium text-text-secondary"
        >
          From
        </label>
        <input
          id="audit-date-from"
          type="date"
          value={dateFrom}
          onChange={(e) => onDateFromChange(e.target.value)}
          className={INPUT_CLASS}
        />
      </div>
      <div>
        <label
          htmlFor="audit-date-to"
          className="mb-1 block text-xs font-medium text-text-secondary"
        >
          To
        </label>
        <input
          id="audit-date-to"
          type="date"
          value={dateTo}
          onChange={(e) => onDateToChange(e.target.value)}
          className={INPUT_CLASS}
        />
      </div>
    </div>
  )
}
